import { uniq } from 'lodash';

import { getItem, setItem } from 'utils/storage/localStorage';

const STORAGE_KEY = 'ytModalStorage';

export function setYTWarningModalBeingShown(campaignId: number, creatorId: number): void {
  const alreadyStoredCampaigns = JSON.parse(getItem(STORAGE_KEY) ?? '{}');
  const storedCampaignData = alreadyStoredCampaigns[campaignId] ?? [];
  alreadyStoredCampaigns[campaignId] = uniq([...storedCampaignData, creatorId]);

  setItem(STORAGE_KEY, JSON.stringify(alreadyStoredCampaigns));
}

export function hasYTWarningModalBeingShown(campaignId: number, creatorId: number): boolean {
  const alreadyStoredCampaigns = JSON.parse(getItem(STORAGE_KEY) ?? '{}');
  const storedCampaignData = alreadyStoredCampaigns[campaignId] ?? [];

  return storedCampaignData.includes(creatorId);
}
